/**
 * Global Keyboard Shortcuts
 * 
 * Hidden shortcuts for developer access.
 */

import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export function useDevShortcuts() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      // Ctrl+Shift+L (or Cmd+Shift+L on Mac) - Open Dev Logs
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'L') {
        e.preventDefault()
        
        // Works from anywhere in the app
        navigate('/dev/logs')
        console.log('🔧 Dev Logs Portal opened')
      }

      // Ctrl+Shift+D - Toggle dev logs collection
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'D') {
        e.preventDefault()
        
        const current = localStorage.getItem('dev_logs_enabled')
        const newValue = current === 'true' ? 'false' : 'true'
        localStorage.setItem('dev_logs_enabled', newValue)
        
        console.log(`🔧 Dev logs ${newValue === 'true' ? 'enabled' : 'disabled'}`)
        
        // Show notification
        const msg = `Dev logs ${newValue === 'true' ? 'enabled' : 'disabled'}. Reload to apply.`
        alert(msg)
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    return () => window.removeEventListener('keydown', handleKeyPress)
  }, [navigate, location])
}
